import { Label } from '@radix-ui/react-label'

import { cn } from '@/libs/tw'

import { Typography } from '../typography/typography'
import { fontStyles } from '../typography/typographyUtils'

type WithLabelProps = {
	label: string
	asLabel?: boolean
	children: string | JSX.Element
}

export const WithLabel = ({ label, asLabel = false, children }: WithLabelProps) => {
	return asLabel ? (
		<Label
			data-testid={label}
			className={cn('flex w-full items-center justify-between gap-x-8', fontStyles['p'])}
		>
			{label}
			{children}
		</Label>
	) : (
		<div data-testid={label} className="flex w-full items-center justify-between gap-x-8">
			<Typography style="p" element="span">
				{label}
			</Typography>
			{children}
		</div>
	)
}
